import { render, staticRenderFns } from "./MultipleText.vue?vue&type=template&id=f42308b0&scoped=true&"
import script from "./MultipleText.vue?vue&type=script&lang=js&"
export * from "./MultipleText.vue?vue&type=script&lang=js&"
import style0 from "./MultipleText.vue?vue&type=style&index=0&id=f42308b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42308b0",
  null
  
)

export default component.exports